import { IconButton } from '@smart-tv/components/icon-button/icon-button';
import { ReplayIcon } from '@smart-tv/components/icons/replay';
import React, { useCallback } from 'react';
import { memo } from 'react';
import { PLAYER_FOCUS_KEY_LIVE, PLAYER_FOCUS_KEY_REPLAY } from '../../player-helpers';
import { LiveIcon } from '@smart-tv/components/icons/live';
import useStream from '../../_hooks/use-stream';
import { StreamType } from '@smart-tv/typings/content';
import useControls from '../../_hooks/use-controls';
import { usePlayerContext } from '../../_contexts/player-context';
import { useSetAtom } from 'jotai';
import { playerBtnsFocusHistoryAtom } from './use-player-controls-navigation';
import useDeactivatePlayerActions from '../_hooks/use-deactivate-player-actions';
import testIds from '@smart-tv/e2e/shared/variables';

const ReplayButtons = () => {
  const { handleBeginStartOver, handleCancelStartOver } = useControls();
  const { streamType } = useStream();
  const { setIsPlaying } = usePlayerContext();
  const setPlayerBtnsFocusHistory = useSetAtom(playerBtnsFocusHistoryAtom);
  const isDeactivated = useDeactivatePlayerActions();

  const handleStartOver = useCallback(() => {
    handleBeginStartOver?.();
  }, [handleBeginStartOver]);

  const handleCancel = useCallback(() => {
    setIsPlaying(true);
    handleCancelStartOver?.();
  }, [handleCancelStartOver, setIsPlaying]);

  return (
    <>
      {streamType === StreamType.LiveStream && (
        <IconButton
          size="xl"
          focusKey={PLAYER_FOCUS_KEY_REPLAY}
          onClick={() => !isDeactivated && handleStartOver()}
          data-testid={testIds.player.playerControls.startOver}
          onNavFocus={() => setPlayerBtnsFocusHistory(PLAYER_FOCUS_KEY_REPLAY)}
          icon={<ReplayIcon />}
        >
          Start forfra
        </IconButton>
      )}

      {streamType === StreamType.StartOver && (
        <IconButton
          size="xl"
          focusKey={PLAYER_FOCUS_KEY_LIVE}
          onClick={() => !isDeactivated && handleCancel()}
          data-testid={testIds.player.playerControls.live}
          onNavFocus={() => setPlayerBtnsFocusHistory(PLAYER_FOCUS_KEY_LIVE)}
          icon={<LiveIcon />}
        >
          Gå til live
        </IconButton>
      )}
    </>
  );
};

export default memo(ReplayButtons);
